var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLdr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 26.667",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.667,10.667H5.333V8H18.667Zm0,5.333H5.333V13.333H18.667Zm-4,5.333H5.333V18.667h9.334ZM12,2.667A1.333,1.333,0,1,1,10.667,4,1.337,1.337,0,0,1,12,2.667Zm9.333,0H15.76a3.984,3.984,0,0,0-7.52,0H2.667A2.674,2.674,0,0,0,0,5.333V24a2.675,2.675,0,0,0,2.667,2.667H21.333A2.675,2.675,0,0,0,24,24V5.333A2.674,2.674,0,0,0,21.333,2.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdr);
export default __webpack_public_path__ + "static/media/LDR.754c77d10a6342bfcba60f78f500b2fe.svg";
export { ForwardRef as ReactComponent };